module.exports = __webpack_public_path__ + "static/media/coin_red.a3747d23.svg";